export const getArrayParams = (array, dataFieldName, apiFieldName) =>
  array.map(i => `${apiFieldName}=${i[dataFieldName]}`).join('&');
